<ng-container *transloco="let t">
  <div class="admin-card">
    <app-admin-actions-header [isPdfVisible]="true" [isXlsVisible]="true">
      <div slot="leadingWidgets" class="d-flex flex-column flex-md-row">
        <div class="d-flex">
          <div class="me-2 mb-md-0">
            <app-search-rounded [placeholder]="t('explore.search')"
                                (searchEmitter)="handleInput($event)"></app-search-rounded>
          </div>
          @if (allCategories.length > 0) {
            <div class="mx-1 d-flex">
              <app-select [hasDefault]="true" [items]="categoryTypes" [ngModel]="selectedCategoryType"
                          class="me-2 mb-md-0 mb-2" [defaultValue]="undefined"
                          [defaultLabel]="t('administrator.categories.allTypes')" [valueKey]="'id'" [labelKey]="'id'"
                          labelKeyPrefix="administrator.categories.type." (ngModelChange)="onCategorySelect($event)"/>
            </div>
          }
          <app-rounded-button [label]="t('administrator.categories.addNewCategory')"
                              [btnClass]="'rounded-button--solid'" (onClick)="toggleCategoryForm()"
                              [isDisabled]="!hideCategoryForm"><i class="bi bi-plus-circle pe-2"></i>
          </app-rounded-button>
        </div>
      </div>
    </app-admin-actions-header>

    @if (selectedCategoriesList.length > 0) {
      <div>
        @for (category of selectedCategoriesList;track category) {
          <ng-container>
            <div class="status-badge accepted fs-16" style="margin-bottom: 12px">
              <span class="fw-bold text-uppercase">
                {{ t("administrator.categories.ageGroup") }} - {{ category.name }}
              </span>
            </div>

            <div class="d-flex align-items-stretch">
              <div class="flex-grow-1">
                <div class="row g-1">
                  <div class="col-6">
                    <div class="grey-cells d-flex justify-content-between">
                      <div class="flex-grow-1 text-center py-2 fw-semibold">
                        {{ t("administrator.categories.type") }}
                      </div>
                      <div class="flex-grow-1 text-center py-2">
                        {{
                          t("administrator.categories.type." + category.categoryType)
                        }}
                      </div>
                    </div>
                    <div class="table-responsive d-xl-block d-none">
                      <table class="table table-last-row-no-border table-transparent">
                        <thead>
                        <tr>
                          <th class="fw-bold center-align text-center">{{
                              t("administrator.categories.ageGroupDetailMen")
                            }}
                          </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                          <td class="padding-0" style="padding-top: 4px;">
                            @if (getItemsMale(category).length > 0) {
                              <table class="table">
                                <thead>
                                <tr>
                                  <td class="center-align fw-semibold">{{ t("administrator.categories.id") }}
                                  </td>
                                  <td class="center-align fw-semibold">{{ t("administrator.categories.name") }}
                                  </td>
                                  <td class="center-align fw-semibold">{{
                                      t("administrator.categories.age.range")
                                    }}
                                  </td>
                                </tr>
                                </thead>
                                <tr app-table-header-separator></tr>
                                <tbody>
                                  @for (item of getItemsMale(category);track item) {
                                    <ng-container>
                                      <tr>
                                        <td class="center-align">{{ item.code }}</td>
                                        <td class="center-align">{{ item.name }}</td>
                                        <td class="center-align">{{ item.ageFrom }} - {{ item.ageTo }}</td>
                                      </tr>
                                    </ng-container>
                                  }
                                </tbody>
                              </table>
                            }
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="grey-cells d-flex justify-content-between">
                      <div class="flex-grow-1 text-center py-2 fw-semibold">
                        {{ t("administrator.categories.raceCount") }}:
                      </div>
                      <div class="flex-grow-1 text-center py-2">
                        {{ category.raceCount ?? "-" }}
                      </div>
                    </div>
                    <div class="table-responsive d-xl-block d-none">
                      <table class="table table-last-row-no-border table-transparent">
                        <thead>
                        <tr>
                          <th class="fw-bold center-align text-center">{{
                              t("administrator.categories.ageGroupDetailWomen")
                            }}
                          </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                          <!-- Women's Age Group Detail Column -->
                          <td class="padding-0 border-left" style="padding-top: 4px;">
                            @if (getItemsFemale(category).length > 0) {
                              <table class="table">
                                <thead>
                                <tr>
                                  <td class="center-align fw-semibold">{{ t("administrator.categories.id") }}
                                  </td>
                                  <td class="center-align fw-semibold">{{ t("administrator.categories.name") }}
                                  </td>
                                  <td class="center-align fw-semibold">{{
                                      t("administrator.categories.age.range")
                                    }}
                                  </td>
                                </tr>
                                </thead>
                                <tr app-table-header-separator></tr>
                                <tbody>
                                  @for (item of getItemsFemale(category);track item) {
                                    <ng-container>
                                      <tr>
                                        <td class="center-align">{{ item.code }}</td>
                                        <td class="center-align">{{ item.name }}</td>
                                        <td class="center-align">{{ item.ageFrom }} - {{ item.ageTo }}</td>
                                      </tr>
                                    </ng-container>
                                  }
                                </tbody>
                              </table>
                            }
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="more-btn-box d-xl-flex d-none align-content-center justify-content-center">
                <div class="dropdown dropdown--remove-arrow" container="body" ngbDropdown>
                                    <span class="menu-icon" id="raceCommercialItemActionsDropdown" ngbDropdownToggle>
                                      <i class="fas fa-ellipsis-v"></i>
                                    </span>
                  <ul aria-labelledby="raceCommercialItemActionsDropdown" ngbDropdownMenu>
                    <li ngbDropdownItem (click)="onEditCategory(category)">
                      {{
                        t(
                          "app.common.edit")
                      }}
                    </li>
                    <li ngbDropdownItem (click)="onDeleteCategory(category)">{{
                        t(
                          "app.common.delete")
                      }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- Mobile table -->
            <div class="d-flex d-xl-none justify-content-between align-items-center mobile-table-row">
              <div class="d-block">
                <!-- Category Information -->
                <div class="d-flex flex-column">
                  <strong>{{ t("administrator.categories.ageGroup") }}</strong>
                  <div class="status-badge accepted my-2 fs-13-px">
                <span class="fw-bold text-uppercase">
                  {{ category.name }}
                </span>
                  </div>
                  {{ t("administrator.categories.type") }}: {{ category.categoryType | categoryType }} <br>
                  {{ t("administrator.categories.raceCount") }}: {{ category.raceCount ?? "-" }}
                </div>

                <!-- Men's Age Group Details -->
                @if (getItemsMale(category).length > 0) {
                  <div>
                    <div class="pt-3"><strong>{{ t("administrator.categories.ageGroupDetailMen") }}</strong></div>
                    <ng-template [ngTemplateOutlet]="ageGroupDetail"
                                 [ngTemplateOutletContext]="{ items: getItemsMale(category) }"></ng-template>
                  </div>
                }
                <!-- Women's Age Group Details -->
                @if (getItemsFemale(category).length > 0) {
                  <div>
                    <div class="pt-3"><strong>{{ t("administrator.categories.ageGroupDetailWomen") }}</strong></div>
                    <ng-template [ngTemplateOutlet]="ageGroupDetail"
                                 [ngTemplateOutletContext]="{ items: getItemsFemale(category) }"></ng-template>
                  </div>
                }

              </div>
              <div class="dropdown dropdown--remove-arrow" container="body" ngbDropdown>
            <span class="menu-icon" ngbDropdownToggle>
              <i class="fas fa-ellipsis-v"></i>
            </span>
                <ul ngbDropdownMenu>
                  <li ngbDropdownItem (click)="onEditCategory(category)">
                    {{
                      t(
                        "app.common.edit")
                    }}
                  </li>
                  <li ngbDropdownItem (click)="onDeleteCategory(category)">{{
                      t(
                        "app.common.delete")
                    }}
                  </li>
                </ul>
              </div>
            </div>
          </ng-container>
        }

      </div>
    } @else {
      <app-empty-state/>
    }
  </div>

  <div #categoryForm="ngbCollapse" id="categoryForm" [(ngbCollapse)]="hideCategoryForm" class="mt-4"
       (shown)="navigateToCategoryForm()">
    <app-category-form [category]="currentCategory" [organiserId]="organiserId" [categoryTypes]="categoryTypes"
                       (cancel)="onCancel()"/>
  </div>

  <!-- Age Group Detail Template -->
  <ng-template #ageGroupDetail let-items="items">
    @for (item of items;track trackByFn;let isLast=$last) {
      <ng-container>
        <div class="d-flex flex-column">
          <div class="d-flex justify-content-center align-items-center mobile-table-row" [class.isLastRow]="isLast">
            <div class="flex-grow-1">
              <div class="d-flex flex-column" [class.isLastRow]="isLast">
                <div>
                  {{ t("administrator.categories.id") }}: {{ item.code }}
                </div>
                <div>
                  {{ t("administrator.categories.name") }}: {{ item.name }}
                </div>
                <div>
                  {{ t("administrator.categories.age.range") }}: {{ item.ageFrom }} - {{ item.ageTo }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    }

  </ng-template>

  @if (hideCategoryForm) {
    <app-action-buttons-row [saveVisible]="false"/>
  }
</ng-container>
